import * as React from "react";
import { Slider, Row, Col, Alert } from "antd";
import styled from "styled-components";
import { SliderValue } from "antd/lib/slider";
import { numberAsHour } from "../lib/formatters";

export const Label = styled.span`
  color: #061a32;
  font-size: 11px;
  font-weight: 300;
`;

const SmallAlert = styled(Alert)`
  font-size: 13px !important;
`;

export const isSmallTimeWindow = (timeWindow: [number, number]): boolean => {
  return timeWindow[1] - timeWindow[0] < 3;
};

type Props = {
  value: [number, number];
  onChange: (value: [number, number]) => void;
};

class TimeWindowPicker extends React.Component<Props> {
  render() {
    const { value } = this.props;
    return (
      <Row type="flex">
        <Col span={24}>
          <Label>Zeitfenster</Label>
        </Col>
        <Col span={24}>
          <Label>
            {numberAsHour(value[0])} - {numberAsHour(value[1])}Uhr
          </Label>
        </Col>
        <Col span={24}>
          <Slider
            range
            step={0.5}
            min={5}
            max={21}
            value={value}
            onChange={this.handleChange}
            tooltipVisible={false}
          />
        </Col>
        <Col span={24}>
          {isSmallTimeWindow(value) && (
            <SmallAlert
              type="success"
              showIcon
              message={
                <>
                  <span>Wählen Sie ein Zeitfenster von mindestens</span>
                  <br />
                  <span>3 Stunden und erhalten Sie 10% Rabatt!</span>
                </>
              }
            />
          )}
        </Col>
      </Row>
    );
  }
  handleChange = (value: SliderValue) => {
    if (typeof value !== "number") {
      this.props.onChange(value);
    }
  };
}

export default TimeWindowPicker;
